import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FilterPagination, RequestInvoices, ResultsInvoice } from '../../interface/company-client.interface';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { CdkContextMenuTrigger } from '@angular/cdk/menu';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { OperationModalComponent } from '../../modals/operation-modal/operation-modal.component';
import { DetalleFactVComponent } from '../information/detalle-fact-v/detalle-fact-v.component';
import { FactoringInvoices } from '../../interface/invoice-operation.interface';
import { PageResult } from 'src/app/common/interfaces/paged-result.interface';

@Component({
  selector: 'app-invoce-sell-factoring',
  templateUrl: './invoce-sell-factoring.component.html',
  styleUrls: ['./invoce-sell-factoring.component.scss']
})
export class InvoceSellFactoringComponent {
  @Input() resultsInvoice: PageResult<FactoringInvoices>;
  @Input() requestInvoice: RequestInvoices;
  @Output() operationBoolean = new EventEmitter();
  @Output() pages: EventEmitter<any> = new EventEmitter();
  @Output() viewInvoiceBuyOrder: EventEmitter<number> = new EventEmitter();
  @Output() changePagination = new EventEmitter<FilterPagination>;
  @Output() changeSortOrder = new EventEmitter<string>;
  @ViewChild(MatSort, { static: true }) sort: MatSort = Object.create(null);
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator = Object.create(null);
  public resultsInvoiceFormula: ResultsInvoice;
  public menu!: CdkContextMenuTrigger;
  public dataModal: ResultsInvoice;
  public dataSource!: MatTableDataSource<ResultsInvoice>;
  public displayedColumns: string[] = [
    'folio',
    'nombreCliente', 
    'rutCliente',  
    'montoTotal',
    'fechaDocto',
    'nombreCesionario',
    'rutCesionario',
    'fechaCesion'
  ]

  constructor(private cdref: ChangeDetectorRef, public dialog: MatDialog,) {}
  ngOnInit() {
  }
  //esto es lo que yo le envio
  ngAfterViewInit() {
    this.paginator.page.subscribe((e) => {
      const pages: FilterPagination = {
        pageSize: e.pageSize,
        page: e.pageIndex + 1,
      };
      this.pages.emit(pages);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(this.resultsInvoice) {
      this.setDataSource(this.resultsInvoice);
    }
    
  }

  setDataSource(dataSource: any) {
    const { results, totalRows, pageSize, currentPage } = dataSource || {};
    this.dataSource = new MatTableDataSource<ResultsInvoice>(results);
    this.dataSource.sort = this.sort;
    this.paginator.pageIndex = currentPage -1;
    this.paginator.length = totalRows;
    this.paginator.pageSize = pageSize;
 }
  setDataSourceRequest(dataSource: RequestInvoices) {
    const { results, currentPage, pageSize, totalRows } = dataSource || {};
    this.dataSource = new MatTableDataSource<ResultsInvoice>(results);
    if (currentPage && pageSize) {
      this.paginator.length = totalRows;
      this.dataSource.sort = pageSize;
    }
  }
  openDialog(invoiceId: number): void {
    this.viewInvoiceBuyOrder.emit(invoiceId);
  }
  openDialogOperation(value: ResultsInvoice): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.width = '60%';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.height = '615px';
    dialogConfig.maxHeight = '90vh';
    dialogConfig.data = value;
    const dialogRef = this.dialog.open(OperationModalComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      this.operationBoolean.emit(result);
    });
  }
  public openDetalleFactura(value: ResultsInvoice) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.width = '60%';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.height = '600px';
    dialogConfig.maxHeight = '90vh';
    dialogConfig.data = value;
    const dialogRef = this.dialog.open(DetalleFactVComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      this.operationBoolean.emit(result);
    });
  }

  changePaginationTable(event: PageEvent) {
    const pagination: FilterPagination = {
      page: event.pageIndex + 1,
      pageSize: event.pageSize
    };
    this.changePagination.emit(pagination);
  }

  sortOrderChange(sortState: Sort) {
    if(sortState.direction === '') {
      this.changeSortOrder.emit(null);
      return;
    }
    const sortCol = sortState.active.charAt(0).toUpperCase() + sortState.active.slice(1);
    const sortConf = `${sortCol}_${sortState.direction}`;
    this.changeSortOrder.emit(sortConf);  
  }

}
